import { Tabulator } from "tabulator-tables";
export const SITE_VERSION = '1.1.0';

export const isLoggedIn = document.querySelector('.logged-in');
export const IS_LOGGED_IN = document.querySelector('.logged-in');
export const terminalStatusContainer = document.querySelector('.aafp_dispenser-status') as HTMLElement;
export const loader = document.querySelector('.aafp_loading') as HTMLElement;
export const FORM_LOADER = document.querySelector('.aafp_loading') as HTMLElement;
export const dashboardContainer = document.querySelector('.aafp_show') as HTMLElement;
export const DASHBOARD_CONTAINER = document.querySelector('.aafp_show') as HTMLElement;

export const WIDGET_CONTAINER = document.querySelector('.aafp_side-form-container') as HTMLElement;

export const cognitoError = document.querySelector('.aafp_error-signup') as HTMLElement;
export const FORM_ERROR_MSG = document.querySelector('.form-error-msg') as HTMLElement;

export const DROP_DOWN = {
  errorMsg: document.querySelector('.dropdown-invalid-feedback') as HTMLElement,
  container: document.querySelector('.aafp_select-data-container-partner') as HTMLElement,
  containerState: document.querySelector('.aafp_select-data-container-address') as HTMLElement
}

export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const PARTNER_LIST = 'PARTNER_LIST';
export const GET_PARTNER = 'GET_PARTNER';

export const PAGE_LOADER = {
  loaderContainer: document.querySelector('.aafp_loading') as HTMLElement,
  loaderMessage: document.querySelector('.aafp_info') as HTMLElement
}

// export const addressForm = {
//   addressForm: document.querySelector('#aafp_address-form') as HTMLFormElement,
//   addressOne: document.querySelector('#aafp_form-terminal-address-one') as HTMLInputElement,
//   addressTwo: document.querySelector('#aafp_form-terminal-address-two') as HTMLInputElement,
//   addressCity: document.querySelector('#aafp_form-terminal-address-city') as HTMLInputElement,
//   addressState: document.querySelector('#aafp_form-terminal-address-state') as HTMLInputElement,
//   addressZip: document.querySelector('#aafp_form-terminal-address-zip') as HTMLInputElement,
//   addressDropDown: document.querySelector('.aafp_select-data') as HTMLElement
// }

export const PARTNER_FORM = {
  partnerForm: document.querySelector('#aafp_add-new-partner') as HTMLFormElement,
  partnerName: document.querySelector('#aafp_form-partner-name') as HTMLInputElement,
  partnerAccountNumber: document.querySelector('#aafp_form-partner-account-number') as HTMLInputElement,
  partnerFileType: document.querySelector('#aafp_form-partner-file-type') as HTMLInputElement,
  partnerSubmit: document.querySelector('#aafp_partner-new-submit') as HTMLInputElement
}

export const TRANSACTION_FITLER = {
  transactionTableGrid: Tabulator,
  searchFilterButton: document.querySelector('#search-date-button') as HTMLElement,
  clearFilterButton: document.querySelector('#clear-filter-button') as HTMLElement,
  startDate: document.querySelector('#search-date-start') as HTMLInputElement,
  endDate: document.querySelector('#search-date-end') as HTMLInputElement,
  partnerList: document.querySelector('.aafp_filter-partners-list') as HTMLElement,
  customerList: document.querySelector('#aafp_customer-list-sort') as HTMLInputElement,
  cardgroupList: document.querySelector('#aafp_cardgroup-list-sort') as HTMLInputElement,
  terminalList: document.querySelector('#aafp_terminal-list-sort') as HTMLInputElement,
  paymentType: document.querySelector('#aafp_payment-list-sort') as HTMLInputElement,
  dateToSet: 7,
  dateToSetTwo: 2
}

export const CUSTOMER_FORM = {
  customerFormContainer: document.querySelector('.aafp_customer-form-container') as HTMLElement,
  customerUpdateForm: document.querySelector('#aafp_update-customer') as HTMLFormElement,
  customerCreateForm: document.querySelector('#aafp_add-new-customer') as HTMLFormElement,
  customerName: document.querySelector('#aafp_form-customer-name') as HTMLInputElement,
  customerAccountNumber: document.querySelector('#aafp_form-customer-account-number') as HTMLInputElement,
  customerGallonLimit: document.querySelector('#aafp_form-customer-limit') as HTMLInputElement,
  customerStatus: document.querySelector('#aafp_form-customer-status') as HTMLSelectElement,
  customerFileType: document.querySelector('#aafp_form-customer-file-type') as HTMLSelectElement,
  customerPartner: document.querySelector('#aafp_dropdown-partner') as HTMLElement,
  customerPartnerNumber: document.querySelector('#aafp_form-customer-partner-number') as HTMLInputElement,
  customerTable: document.querySelector('.aafp_customer-list') as HTMLElement,
  customerSubmit: document.querySelector('#aafp_customer-submit') as HTMLElement
}

// export const CARD_GROUP_FORM = {
//   cgForm: document.querySelector('#aafp_add-card-group') as HTMLFormElement,
//   cgUpdateForm: document.querySelector('#aafp_update-card-group') as HTMLFormElement,
//   cgSearch: document.querySelector('#aafp_customer-input') as HTMLInputElement,
//   cgSearchButton: document.querySelector('#aafp_customer-find') as HTMLInputElement,
//   cgResults: document.querySelector('.aafp_customer-container') as HTMLElement,
//   cgSelectedCustContainer: document.querySelector('.aafp_customer-result-container') as HTMLElement,
//   cgCustomerID:  document.querySelector('.aafp_form-card-group-customer')  as HTMLElement,
//   cgName: document.querySelector('#aafp_form-card-group-name') as HTMLInputElement,
//   cgPaymentMethod: document.querySelector('#aafp_form-card-group-payment') as HTMLSelectElement,
//   cgMarginCents: document.querySelector('#aafp_form-card-group-margin') as HTMLInputElement,
//   cgTimeoutOverride: document.querySelector('#aafp_form-card-group-override') as HTMLInputElement,
//   cgSubmitButton: document.querySelector('#aafp_new-card-group-submit') as HTMLElement,
// }

export const PAYMENT_TYPE_LIST = [
  { id: 2, name: 'Pay at Pump/Invoice' },
  { id: 0, name: 'Pay at Pump' },
  { id: 1, name: 'Invoice' },
];